import { AppStoreState, TDispatchAction } from '.'
import {
    ACTION_SET_IS_MOBILE,
    ACTION_SET_USER,
    ACTION_SET_LAST_BLOCK_UPDATE,
    ACTION_SET_CONTACT_INFO,
    ACTION_SET_RESUME,
    ACTION_SET_LIST_MORE_SECTION_LENGTH,
    ACTION_SET_LIST_WORK_HISTORY,
    ACTION_SET_LANGUAGE,
    ACTION_SET_BREAKPOINT,
    ACTION_SET_DEVICE,
    ACTION_SET_PROFILE_LEVEL,
    ACTION_SET_LIST_JOB_ALERT,
    ACTION_SET_RESUME_SETTING_INFO,
    ACTION_LOADING,
    ACTION_FINISHED,
    ACTION_SET_BASIC_INFO,
    ACTION_SET_RECOMMENDATIONS,
    ACTION_SET_RECOMMENDATION_FROM_REFERENCE,
    ACTION_SET_RESUME_DETAIL,
    ACTION_SHOW_SETTING_PROFILE
} from './actions'

const reducer = (state: AppStoreState, action: TDispatchAction) => {
    switch (action.type) {
        case ACTION_SET_USER: {
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            }
        }
        case ACTION_SET_IS_MOBILE: {
            return {
                ...state,
                isMobile: action.payload || false
            }
        }
        case ACTION_SET_DEVICE: {
            if (state.device !== action.payload) {
                return {
                    ...state,
                    device: action.payload
                }
            } else {
                return state
            }
        }
        case ACTION_SET_PROFILE_LEVEL: {
            return {
                ...state,
                profileLevel: action.payload
            }
        }
        case ACTION_SET_LAST_BLOCK_UPDATE: {
            return {
                ...state,
                lastBlockUpdate: [...state.lastBlockUpdate, action.payload.lastBlockUpdate],
                isDowngraded: action.payload.isDowngraded
            }
        }
        case ACTION_SET_CONTACT_INFO: {
            return {
                ...state,
                resume: {
                    ...state.resume,
                    contactInfo: {
                        ...state.resume.contactInfo,
                        ...action.payload
                    }
                }
            }
        }
        case ACTION_SET_RESUME: {
            return {
                ...state,
                resume: {
                    ...state.resume,
                    ...action.payload
                }
            }
        }
        case ACTION_SET_LIST_MORE_SECTION_LENGTH: {
            return {
                ...state,
                listMoreSectionsLength: action.payload
            }
        }
        case ACTION_SET_LIST_WORK_HISTORY: {
            return {
                ...state,
                workHistoryList: action.payload
            }
        }
        case ACTION_SET_LANGUAGE: {
            return {
                ...state,
                langCode: action.payload
            }
        }
        case ACTION_SET_BREAKPOINT: {
            return {
                ...state,
                breakpoint: action.payload
            }
        }
        case ACTION_SET_LIST_JOB_ALERT: {
            return {
                ...state,
                listJobAlert: action.payload
            }
        }
        case ACTION_SET_RESUME_SETTING_INFO: {
            return {
                ...state,
                profileSettingInfo: action.payload
            }
        }
        case ACTION_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        case ACTION_FINISHED: {
            return {
                ...state,
                loading: false
            }
        }
        case ACTION_SET_BASIC_INFO: {
            return {
                ...state,
                profileInfo: action.payload
            }
        }
        case ACTION_SET_RECOMMENDATIONS: {
            return {
                ...state,
                recommendations: action.payload
            }
        }
        case ACTION_SET_RECOMMENDATION_FROM_REFERENCE: {
            return {
                ...state,
                recommedation: action.payload
            }
        }
        case ACTION_SET_RESUME_DETAIL: {
            return {
                ...state,
                resumeDetail: action.payload.resumeDetail
            }
        }
        case ACTION_SHOW_SETTING_PROFILE: {
            return {
                ...state,
                isShowPopupSetting: action.payload
            }
        }
    }

    return state
}

export default reducer
